import { ID } from "src/libs/interfaces/layouts";
import { HISTORY_TYPE, IHistoryStep, ILanding, ILandingSection, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces";
import { useLandingStore } from "src/modules/pe-landing-module/data/store";
import updateSection from "../utils/updateSection";

export function singleChange (
    makeupType: SELECT_TYPE,
    preset: any, 
    classSource: string,
    sectionID: ID | undefined = undefined, 
    meatOrFloatID: ID | undefined = undefined, 
    parentMeatType: SELECT_TYPE = SELECT_TYPE.SECTION 
) {
    if( !sectionID ) {
        return
    }
    if( parentMeatType === SELECT_TYPE.SECTION ) {
        const landing: ILanding         = useLandingStore.getState().currentLanding
        const section: ILandingSection  = landing.sections.find(s => s.id === sectionID) || {} as ILandingSection
        let newSection, step:IHistoryStep
        switch( makeupType ) {
            case SELECT_TYPE.DESCRIPTION:
            case SELECT_TYPE.TITLE:
                newSection = JSON.parse(JSON.stringify({
                    ...section,
                    [ makeupType ]: {
                        text: section[makeupType].text,
                        ...preset
                    }
                }))
                step = {
                    data: section,
                    prevData: newSection,
                    type: HISTORY_TYPE.SECTION,
                    title: "Change Section's " + makeupType
                }
                updateSection(newSection, step)
                return
             case SELECT_TYPE.VERTICAL_TIMELINE:
             case SELECT_TYPE.SECTION_TIMELINE:
                newSection = JSON.parse(JSON.stringify({
                    ...section,
                    ...preset
                }))
                step = {
                    data: section,
                    prevData: newSection,
                    type: HISTORY_TYPE.SECTION,
                    title: "Change Section vertical timeline design"
                }
                updateSection(newSection, step)
                return
             case SELECT_TYPE.ACCORDEON:
             case SELECT_TYPE.HACCORDEON:
                newSection = JSON.parse(JSON.stringify({
                    ...section,
                    haccordeon_design: preset
                }))
                step = {
                    data: section,
                    prevData: newSection,
                    type: HISTORY_TYPE.SECTION,
                    title: "Change Section accordeon design"
                }
                updateSection(newSection, step)
                return
            case SELECT_TYPE.HORIZONTAL_TAB:
            case SELECT_TYPE.VERTICAL_TAB:
                newSection = JSON.parse(JSON.stringify({
                    ...section,
                    tabs_design_type: preset.className
                }))
                step = {
                    data: section,
                    prevData: newSection,
                    type: HISTORY_TYPE.SECTION,
                    title: "Change Section tabulation design"
                }
                updateSection(newSection, step)
                return
            default:
                alert(`${ makeupType } IS NOT HAVE ACTION!!!`)
                return
        }
    }
    else if (parentMeatType === SELECT_TYPE.CONTENT){
        alert(`MEAT ${ makeupType } IS NOT HAVE ACTION!!!`)
    }
    else if (parentMeatType === SELECT_TYPE.FLOAT){
        alert(`FLOAT ${ makeupType } IS NOT HAVE ACTION!!!`)
    }
}